var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStormy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 157,
    viewBox: "0 0 169 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.616 121.633C106.174 120 105.58 117.922 103.428 117.922H88.213L115.487 63.895C116.377 62.262 115.709 61 114.077 61H81.971C79.819 61 79.077 61.742 78.409 63.301L64.315 126.309C63.498 128.164 64.315 129.277 66.244 129.277H79.159L68.991 153.918C68.619 154.883 68.842 155.699 69.51 155.996C70.178 156.293 70.994 156.07 71.811 155.254L104.616 121.633Z",
    fill: "url(#paint0_linear_2012_35)"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -20,
    y: -20,
    width: 208.67,
    height: 151.718
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(10px)",
      clipPath: "url(#bgblur_0_2012_35_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-figma-bg-blur-radius": 20,
    d: "M76.643 0.625C97.351 0.625 114.363 11.84 123.65 30.274L123.824 30.618H124.209C149.532 30.618 168.045 47.89 168.045 70.715C168.045 93.36 149.921 111.093 126.467 111.093H34.581C23.743 111.093 15.261 107.628 9.493 102.075C3.724 96.522 0.625 88.838 0.625 80.312C0.625 65.573 9.954 53.952 23.813 50.002L24.227 49.885L24.265 49.456C26.707 21.613 49.591 0.625 76.643 0.625Z",
    fill: "#FFEBA3",
    fillOpacity: 0.6,
    stroke: "url(#paint1_linear_2012_35)",
    strokeWidth: 1.25
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2012_35_clip_path",
    transform: "translate(20 20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.643 0.625C97.351 0.625 114.363 11.84 123.65 30.274L123.824 30.618H124.209C149.532 30.618 168.045 47.89 168.045 70.715C168.045 93.36 149.921 111.093 126.467 111.093H34.581C23.743 111.093 15.261 107.628 9.493 102.075C3.724 96.522 0.625 88.838 0.625 80.312C0.625 65.573 9.954 53.952 23.813 50.002L24.227 49.885L24.265 49.456C26.707 21.613 49.591 0.625 76.643 0.625Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2012_35",
    x1: 115.883,
    y1: 61,
    x2: 35.909,
    y2: 104.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBEB71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4BB5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2012_35",
    x1: 0.00000313178,
    y1: -0.00000468746,
    x2: 169,
    y2: 112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716548,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStormy);
export default __webpack_public_path__ + "static/media/Stormy.4a420360de5d9b82b0b16e763e53f064.svg";
export { ForwardRef as ReactComponent };